import { createContext } from 'react';

import { CarePlanServiceState } from './care-plan-service.model';

export const CarePlanServiceContext = createContext<CarePlanServiceState | undefined>(undefined);

CarePlanServiceContext.displayName = 'CarePlanServiceContext';
